const config = {
    BASE_URL: "/v1/auth",

};

export default config;